import { useState, useCallback } from 'react';
import { apiClient } from '../utils/apiClient';
import { API_CONFIG } from '../config/apiConfig';

export interface FromSiteWhidOption {
  whid: string;
  organizationId: string;
}

interface ApiResponse {
  success: boolean;
  data?: Array<{ whid: string; organizationId: string }>;
  error?: string;
}

export const useFromSiteWhid = () => {
  const [data, setData] = useState<FromSiteWhidOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchFromSiteWhid = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.get<ApiResponse>(API_CONFIG.ENDPOINTS.GET_FROM_SITE_WHID);

      let responseData = response.data;
      if (response.data.data && typeof response.data.data === 'object' && 'statusCode' in response.data.data) {
        responseData = JSON.parse((response.data.data as any).body);
      }

      if (responseData.success && Array.isArray(responseData.data)) {
        const whids = responseData.data
          .map((item: any) => ({
            whid: item.whid || item.WHID || '',
            organizationId: String(item.organizationId || item.ORGANIZATION_ID || item.organization_id || '')
          }))
          .filter((item: FromSiteWhidOption) => item.whid);
        setData(whids);
      } else {
        throw new Error(responseData.error || 'Failed to fetch From Site WHID');
      }
    } catch (err: any) {
      console.error('From Site WHID Error:', err);
      setError(err.message || 'Error fetching From Site WHID');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, isLoading, error, fetchFromSiteWhid };
};
